export default ({ request }) => ({
    ecomHxSpuListApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/list',
        method: 'post',
        data,
      })
    },
    ecomHxSpuDetailApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/detail',
        method: 'post',
        data,
      })
    },
    ecomHxSpuSaveApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/save',
        method: 'post',
        data,
      })
    },
    ecomHxSpuDelApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/del',
        method: 'post',
        data,
      })
    },
    ecomHxSpuFullMemberApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/fullMember',
        method: 'post',
        data,
      })
    },
    ecomHxSpuApplyApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/apply',
        method: 'post',
        data,
      })
    },
    ecomHxSpuApprovedApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/approved',
        method: 'post',
        data,
      })
    },
    ecomHxSpuRejectApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/reject',
        method: 'post',
        data,
      })
    },
    ecomHxSpuBindSpuBySpuCodeApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/bindSpuBySpuCode',
        method: 'post',
        data,
      })
    },
    ecomHxSpuAddSkuApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/add/sku',
        method: 'post',
        data,
      })
    },
  
    // SPU 产品图片
    ecomHxSpuImageListApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/image/list',
        method: 'POST',
        data,
      })
    },
    ecomHxSpuImageUploadApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/image/upload',
        method: 'POST',
        data,
      })
    },
    ecomHxSpuImageSetDefaultApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/image/setDefault',
        method: 'POST',
        data,
      })
    },
    ecomHxSpuImageDelApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/image/del',
        method: 'POST',
        data,
      })
    },
    ecomHxSpuNewCollectionApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/new/collection',
        method: 'POST',
        data,
      })
    },
    ecomHxSpuRemoveSkuApi(data = {}) {
      return request({
        url: '/ecom/hx/spu/removeSku',
        method: 'POST',
        data,
      })
    },
    ecomHxSkuListBySpuCodeApi(data = {}) {
      return request({
        url: '/ecom/hx/sku/listBySpuCode',
        method: 'POST',
        data,
      })
    },
  })
  